import { TRIP_TYPE_CODES } from '@/constants';
import { TRIP_TYPE_NAMES } from 'utils/constants';

import bookingGrey from '../../images/booking-grey.svg';
import calendarGrey from '../../images/calendar-grey.svg';
import carGrey from '../../images/car-grey.svg';
import folderGrey from '../../images/folder-grey.svg';
import hashtagGrey from '../../images/hashtag-grey.svg';
import locationGrey from '../../images/location-grey.svg';
import messageGrey from '../../images/message-grey.svg';
import settingsGrey from '../../images/settings-grey.svg';

export const FILTER_ICONS = {
  uuid: folderGrey,
  status: locationGrey,
  service: settingsGrey,
  date: calendarGrey,
  provider: carGrey,
  bookingType: bookingGrey,
  confirmationNumber: hashtagGrey,
  tripTypes: folderGrey,
  notes: messageGrey,
};

export const STATUSES = {
  APPROVAL_DENIED: 'approvalDenied',
  APPROVAL_PENDING: 'approvalPending',
  ARRIVED_AT_PU: 'driverArrived',
  ASSIGNMENT_ACCEPTED: 'accepted',
  ASSIGNMENT_CANCELLED: 'assigneeCancelled',
  ASSIGNMENT_DISPATCHED: 'assigneeDispatched',
  ASSIGNMENT_ERROR: 'assignmentError',
  ASSIGNMENT_EXPORTED: 'assignmentExported',
  ASSIGNMENT_PENDING: 'assignmentPending',
  ASSIGNMENT_REJECTED: 'assignmentRejected',
  ASSIGNMENT_UNAVAILABLE: 'assigneeUnavailable',
  COMPLETED: 'completed',
  EN_ROUTE: 'driverEnRoute',
  EXPIRED: 'expired',
  PATIENT_CANCELLED: 'patientCancelled',
  POB: 'passengerOnBoard',
  READY_TO_ASSIGN: 'readyToAssign',
  REQUESTER_CANCELLED: 'requesterCancelled',
  DENIED: 'denied',
  NO_SHOW: 'memberNoShow',
};

export const BOOKING_TYPE_NAMES = {
  ARRIVE_BY: 'Appointment Time', // DENOTES A SCHEDULED DROPOFF TIME
  WILLCALL: 'Will Call',
  ONDEMAND: 'On Demand',
  SCHEDULED: 'Pickup Time', // DENOTES A SCHEDULED PICKUP TIME
};

export const WILL_CALL = 'WILLCALL';

export const DEFAULT_COOKIES = [
  [
    { idx: 0, isChecked: true },
    { idx: 1, isChecked: true },
    { idx: 2, isChecked: true },
    { idx: 3, isChecked: true },
    { idx: 4, isChecked: true },
    { idx: 5, isChecked: false },
    { idx: 6, isChecked: true },
    { idx: 7, isChecked: true },
    { idx: 8, isChecked: false },
    { idx: 9, isChecked: false },
    { idx: 10, isChecked: false },
    { idx: 11, isChecked: false },
    { idx: 12, isChecked: false },
    { idx: 13, isChecked: false },
    { idx: 14, isChecked: false },
    { idx: 15, isChecked: false },
    { idx: 16, isChecked: false },
    { idx: 17, isChecked: false },
    { idx: 18, isChecked: false },
    { idx: 19, isChecked: false },
    { idx: 20, isChecked: false },
    { idx: 21, isChecked: false },
    { idx: 22, isChecked: false },
    { idx: 23, isChecked: false },
  ],
  [
    { idx: 0, isChecked: true },
    { idx: 1, isChecked: true },
    { idx: 2, isChecked: true },
    { idx: 3, isChecked: true },
    { idx: 4, isChecked: true },
  ],
  [
    { idx: 0, isChecked: true },
    { idx: 1, isChecked: true },
    { idx: 2, isChecked: true },
    { idx: 3, isChecked: true },
    { idx: 4, isChecked: true },
  ],
];

export const TRIP_TABLE_COL_COOKIE_NAME = 'tripTableColumns';

export const colDragAreaTitles = [
  `General Information`,
  `Pickup Information`,
  `Drop-Off Information`,
];

export const TRIP_TYPE_STYLES = {
  [TRIP_TYPE_CODES.MILEAGE_REIMBURSEMENT]: {
    title: TRIP_TYPE_NAMES.MILEAGE_REIMBURSEMENT,
    background: 'white',
    color: '#E97E00',
  },
  [TRIP_TYPE_CODES.PUBLIC_TRANSPORTATION]: {
    title: TRIP_TYPE_NAMES.PUBLIC_TRANSPORTATION,
    background: 'white',
    color: '#504CFF',
  },
  [TRIP_TYPE_CODES.SCHEDULED]: {
    title: TRIP_TYPE_NAMES.SCHEDULED,
    background: 'white',
    color: '#0FBBBB',
  },
  [TRIP_TYPE_CODES.ANCILLARY_SERVICES]: {
    title: TRIP_TYPE_NAMES.ANCILLARY_SERVICES,
    background: 'white',
    color: '#716DAE',
  },
  IN_NETWORK: {
    title: 'In Network',
    background: 'white',
    color: '#6B6B6B',
  },
  OUT_OF_NETWORK: {
    title: 'Out of Network',
    background: 'white',
    color: '#6B6B6B',
  },
  VOLUNTEER: { title: 'Volunteer', background: 'white', color: '#0FBBBB' },
};

export const TRIP_TABLE_PARAMS_KEY = {
  CREATED_AT_DATE_TIME_RANGE: 'createdAtDateTimeRange',
  REQUESTED_PICKUP_DATE_TIME_RANGE: 'requestedPickupDateTimeRange',
  REQUESTED_TRIP_TYPE: 'requestedTripType',
};

export const TRIP_NOTE_TYPES_PARAMS = {
  requester: 'containsRequesterNotes',
  driver: 'containsInstructions',
};
